import React from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

const ForgotPasswordModal = ({
    show,
    onHide,
    onSubmit,
    loading = false,
    error = '',
    email = '',
    onEmailChange,
    usuario = '',
    onUsuarioChange,
}) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton className="p-3 pb-0">
            <Modal.Title>Recuperar contraseña</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Ingresa tu correo y usuario para recibir el código de verificación.</p>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={onSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Usuario</Form.Label>
                    <Form.Control
                        type="text"
                        value={usuario}
                        onChange={(e) => onUsuarioChange?.(e.target.value)}
                        placeholder="Ingrese su usuario"
                        autoFocus
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Correo electrónico</Form.Label>
                    <Form.Control
                        type="email"
                        value={email}
                        onChange={(e) => onEmailChange?.(e.target.value)}
                        placeholder="Ingrese su correo"
                    />
                </Form.Group>
                <div className="d-flex justify-content-end">
                    <Button variant="primary" type="submit" disabled={loading || !usuario || !email}>
                        {loading ? 'Enviando...' : 'Enviar código'}
                    </Button>
                </div>
            </Form>
        </Modal.Body>
    </Modal>
);

export default ForgotPasswordModal;
